import Helpers from './Helpers';

let vxpay;

function initialize() {
	if (!window.vxpay && typeof window.ModalboxPayment !== 'undefined') {
		window.vxpay = vxpay = new window.ModalboxPayment(
			{
				'baseUrl': 'https://www.visit-x.net/VXPAY-V3/',
			},
			window,
			{
				'pfm':  3700,
//				'environment':   VXConfig.vxPay.environment,
//				'flow':          VXConfig.vxPay.flow,
				'lang': Helpers.getLanguage(),
//				'w':             VXConfig.wmId,
//				'ws':            VXConfig.wmSubref,
//				'wt':            VXConfig.wmToken,
//				'adtv':          VXConfig.adtv,
//				'sub':           VXConfig.subref,
//				'enableTab':     isMobileRequest() || VXConfig.guestIsLoggedIn,
//				'option':        VXConfig.vxPay.option,
//				'pc':            VXConfig.vxPay.promoCode,
//				'tt':            VXConfig.vxPay.token,
//				'ruri':          VXConfig.vxPay.sessionStartEntryUrl,
//				'host':          VXConfig.vxPay.actorIdOrName,
//				'externalRefId': VXConfig.vxPay.externalRefId,
//				'externalToken': VXConfig.vxPay.externalToken,
			},
		);
	}
}

const defaultOptions = {
	hideAVSAfterPayment: true,
	texts:               {
		"SignupThankYouText": "Wir haben Dir eine Bestätigungsemail mit einem Link zum Zugang an \n" +
			                      "die unten genannte E-Mail-Adresse gesendet. Wenn Du sie nicht finden kannst, \n" +
			                      "ist sie vielleicht im Spam gelandet:",
	},
};

const VXPay = {
	getBalance(fnc) {
		initialize();
		vxpay.getBalance(fnc);
	},

	isLoggedIn(fnc) {
		initialize();
		vxpay.isLoggedIn(fnc);
	},

	onSuccess: function(callback) {
		initialize();

		vxpay.onSuccess = (result) => {
			callback(result);
		};
	},

	openLogin(options = {}) {
		initialize();
		vxpay.openLogin({...defaultOptions, ...options});
	},

	openSignup(options = {}) {
		initialize();
		vxpay.openSignup({...defaultOptions, ...options});
	},

	openPaytour(options = {}) {
		initialize();
		vxpay.openPaytour('', {...defaultOptions, ...options});
	},

	logout(fnc) {
		initialize();
		vxpay.logout(fnc);
	},
};

export default VXPay;



// WEBPACK FOOTER //
// ./src/VXPay.js